// 医生类型
export const getOperateName = (status: number) => {
    switch (Number(status)) {
      case 1:
        return "主执业"
      case 2:
        return "多点执业"
      default:
        return "-"
    }
  }

// 学历
export const getEducationName = (status: number) => {
    switch (status) {
      case 0:
        return "小学"
      case 1:
        return "初中"
      case 2:
        return "高中"
      case 3:
        return "专科"
      case 4:
        return "本科"
      case 5:
        return "硕士研究生"
      case 6:
        return "博士研究生"
      case 7:
        return "传统医学师承和确有专长"
      case 8:
        return "无学历"
      default:
        return ""
    }
  }

//执业级别
export const getPracticeLevelName = (status: number) => {
    switch (Number(status)) {
      case 0:
        return "执业医师"
      case 1:
        return "执业助理医师"
      case 2:
        return "乡镇执业助理医师"
      case 3:
        return "执业助理医师(师承)"
      case 4:
        return "执业医师(师承)"
      case 5:
        return "乡村全科执业助理医师"
      default:
        return "-"
    }
  }

//执业类别
export const getPracticeCategoryName = (status: number) => {
    switch (Number(status)) {
      case 0:
        return "临床"
      case 1:
        return "口腔"
      case 2:
        return "中医"
      case 3:
        return "中西医结合"
      case 4:
        return "公共卫生"
      case 5:
        return "临床和中医"
      case 6:
        return "壮医"
      default:
        return "-"
    }
  }

//任职资格
export const getAppointName = (status: number) => {
    switch (Number(status)) {
      case 1:
        return "医师"
      case 2:
        return "医士"
      case 3:
        return "主治医师"
      case 4:
        return "副主任医师"
      case 5:
        return "主任医师"
      case 7:
        return "其它"
      default:
        return "-"
    }
  }


//抗菌权限
export const getAntibacterialName = (status: number) => {
    switch (Number(status)) {
      case 0:
        return "无权限"
      case 1:
        return "非限制级"
      case 2:
        return "限制级"
      case 3:
        return "特殊级"
      default:
        return "-"
    }
  }

//精麻权限
export const getAnestheticDrugName = (status: number) => {
    switch (Number(status)) {
      case 0:
        return "无权限"
      case 1:
        return "有权限"
      default:
        return "-"
    }
  }
//性别
export const getSexName = (status: number) => {
    switch (Number(status)) {
      case 0:
        return "未知"
      case 1:
        return "男"
      case 2:
        return "女"
      default:
        return "-"
    }
  }

// 医生状态
export const getDoctorName = (status: number) => {
  switch (Number(status)) {
    case 0:
      return "离职"
    case 1:
      return "在职"
    default:
      return "-"
  }
}


  // key
  export const getDoctorKey = (word: string) => {
    switch (word) {
        case 'type':
            return '人员类型'
        case 'name':
            return '医生姓名'
        case 'physicianType':
            return '医生类型'
        case 'sex':
            return '性别'
        case 'birthday':
            return '出生年月'
        case 'nation':
            return '民族'
        case 'identityCard':
            return '身份证号码'
        case 'education':
            return '学历'
        case 'graduationSchool':
            return '毕业学校'
        case 'qualification':
            return '资格证书编号'
        case 'practice':
            return '执业证书编号'
        case 'practiceLevel':
            return '执业级别'
        case 'practiceCategory':
            return '执业类别'
        case 'practiceArea':
            return '执业范围'
        case 'appoint':
            return '任职资格'
        case 'antibacterialDrugPermission':
            return '抗菌权限'
        case 'anestheticDrugPermission':
            return '精麻权限'
        case 'licenceOrgan':
            return '发证机关'
        case 'licenceDate':
            return '执业发证日期'
        case 'qualificationDate':
            return '资格发证日期'
        case 'workState':
            return '医生状态'
        default:
            return '-'
    }
  }